var $ = require('jquery');

(function() {
    var self = this;
    var selectorTrial = '[data-oao-trial="true"]';
    var selectorInactive = '[data-oao-inactive="true"]';
    var selectorShopLink = '.expirationNotice .buybox .shoplink';
    var selectorShopButton = '.expirationNotice .buybox .shop';

    var reloadDialog = null;

    // handle clicking on the package link in the trial bar
    this.initTrialLink = function () {
        // fetch relevant elements
        var shopLink = $(selectorShopLink);
        var shopButton = $(selectorShopButton);

        // only certain links need to open in a popup
        if (shopLink.attr("data-popup") !== "1") {
            return;
        }

        // fetch the source URL and determine if it's an image
        var src = shopLink.attr('href');
        var srcIsImage = /\.(png|jpe?g|gif|bmp)$/i.test(src);

        shopButton.bind('click', function(evt) {
            self.openReloadDialog();
        })

        // handle click on the link
        shopLink.bind('click', function (evt) {

            // don't want link click to propagate
            evt.preventDefault();

            // open a popup using that link's URL
            var layer = diy.appUpsell.openLayer(src, {
                //XXX: images are not loaded in iframe, see below
                layerIsDiv: srcIsImage,
                // options for the dialog
                layerOptions: {
                    width: Math.min(980, $(window).width() - 10),
                    height: Math.min(700, $(window).height() - 10),
                    title: shopLink.attr("data-popupTitle")

                    // Temporary commented out to disable the button for trial2Pay conversion
                    // this is done due to DHDIY-21830
                    /**,
                    buttons: [{
                        text: shopButton.attr('title'),
                        click: function () {
                            // KPI tracking
                            $(document).trigger('diy-editor-trial-buy-now-clicked', {
                                'loggedIn': true,
                                'sourceButton': 'yourPackageBuyNow'
                            });
                            // close dialog
                            diy.appUpsell.closeLayer();

                            self.openReloadDialog();

                            // follow the button link
                            var shopURL = shopButton.attr('href');
                            if (diy.tracking) {
                                shopURL = diy.pfcSupport.setLinkParamToString(shopURL, 64);
                            }
                            window.open(shopURL);
                        }
                    }]
                     **/
                }
            });

            // XXX: if you load an image in an iframe that's too small for it,
            // the browser will shrink to fit; we don't want that, so we asked
            // the layer to be a div instead of an iframe, and now we inject
            // the image manually into it
            if (srcIsImage) {
                var img = $('<img>');
                img.appendTo(layer);
                img.attr('src', shopLink.attr('href'));
            }

        });
    }; /* end of initTrialLink */

    this.initButtons = function() {
        if (top.jQuery('.trial-layer').length == 0) {
            top.jQuery('body').append('<div class="trial-layer hidden" />');
        }

        $(selectorTrial)
            .click($.proxy(this.showWindow, this));

        $(selectorInactive)
            .mousemove($.proxy(this.showTooltip, this))
            .mouseout($.proxy(this.onBtnOut, this))
            .click(function(e){
                e.preventDefault();
                self.showTooltip(e);
            });
        $(window).scroll($.proxy(this.onBtnOut, this));
    };

    this.onBtnOut = function(evt) {
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
        }
    };

    this.showTooltip = function(evt) {
        var tooltip = jimdoData.messages.testdrive.tooltipForLinks;
        if (evt.pageX && evt.pageY) {
            if (!self._tooltipCt) {
                self._tooltipCt = $('<div />').diy_simpleTooltip({
                    anchorToTarget: false,
                    trackMouse: true,
                    zIndex: 200000,
                    cls: 'diy-info-tooltip',
                    position: {
                        collision: 'fit'
                    },
                    triggerMode: 'none',
                    content: tooltip
                });
            }
            self._tooltipCt.diy_simpleTooltip('show', evt);
        } else if (evt.currentTarget) {
            // this is the case when a click was triggered in code
            // not by user click
            $(evt.currentTarget).diy_tooltip({
                anchor: 'right',
                alignment: 'center',
                closable: true,
                triggerMode: 'none',
                autoHide: false,
                content: tooltip,
                title: ' '
            });
            $(evt.currentTarget).diy_tooltip('show');
        }
    };

    this.hideLayer = function() {
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
            self._tooltipCt.diy_simpleTooltip('destroy');
            self._tooltipCt = null;
        }
    };

    this.showWindow = function(e) {
        //var $element = top.jQuery('.trial-layer').length ? $('.trial-layer') : $('.trial-layer', window.parent.document.body);
        var $element = top.jQuery('.trial-layer');
        e.preventDefault();

        $element
            .html(jimdoData.testdrive.popupContent)
            .removeClass('hidden')
            .diy_dialog({
                title: jimdoData.messages.testdrive.popupTitle,
                modal: true,
                width: 480,
                draggable: false,
                buttons: [{
                    text: jimdoData.messages.testdrive.popupPrimaryButton,
                    click: function() {
                        var openingTargetButton = e.currentTarget ? e.currentTarget : e.target;
                        var sourceHandlerName = $(openingTargetButton).attr('name');
                        $(document).trigger('diy-editor-trial-buy-now-clicked', {
                            'loggedIn': true,
                            'sourceButton': sourceHandlerName
                        });

                        //close the dialog and open the reload dialog
                        top.jQuery(this).diy_dialog("close");
                        self.openReloadDialog();

                        var shopURL = (diy.tracking && sourceHandlerName) ?
                            diy.pfcSupport.setLinkParamToString(
                                jimdoData.testdrive.shopURL,
                                diy.pfcSupport.pfcs[sourceHandlerName]) :
                            jimdoData.testdrive.shopURL;
                        window.open(shopURL);
                    }
                },

                    {
                        text: jimdoData.messages.testdrive.popupSecondaryButton,
                        "class": "button-cancel",
                        click: function() {
                            top.jQuery(this).diy_dialog("close");
                        }
                    }],
                resizable: false,
                zIndex: 100100
            });
        this.hideLayer();
    };

    this.getReloadDialog = function() {
        if (null == reloadDialog) {
            var dlgHTML = '<div id="reloadDialog">'
                + '<div class="dialog-wrapper with-icon">'
                + '<div class="dialog-icon ui-icon ui-icon-alert"></div>'
                + '<h2 class="dialogContentTitle">'+jimdoData.messages.testdrive.reloadDialog.title+'</h2>'
                + '<p class="dialogMessage">'+jimdoData.messages.testdrive.reloadDialog.text+'</p>'
                + '</div></div>';
            var $dlgMarkup = $(dlgHTML);

            reloadDialog = $dlgMarkup.diy_dialog({
                    title: jimdoData.messages.testdrive.reloadDialog.windowTitle,
                    modal: true,
                    zIndex: 210000,
                    overlayCls: null,
                    minHeight: false,
                    closeOnEscape: false,
                    draggable: false,
                    autoOpen: false,
                    buttons: [{
                        text: jimdoData.messages.testdrive.reloadDialog.buttonText,
                        click: (function(){
                            $(document).trigger('diy-editor-generic-linkInteraction', {actionName: "reloadDialogReload"});
                            location.reload();
                        })
                    },
                        {
                            text: jimdoData.messages.testdrive.reloadDialog.closeButton,
                            "class": "button-cancel",
                            click: function() {
                                $(document).trigger('diy-editor-generic-linkInteraction', {actionName: "reloadDialogClose"});
                                top.jQuery(this).diy_dialog("close");
                            }
                        }
                    ]
                }

            );
        }
        return reloadDialog;
    };

    this.openReloadDialog = function() {
        if (null == reloadDialog) {
            reloadDialog = self.getReloadDialog();
        }
        reloadDialog.dialog("open");
    }

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/common/js/trialLayer.js
 ** module id = 1136
 ** module chunks = 0 8
 **/